import { isArray, isString, isObject, isSerializableNumber, or, and, isSome } from 'isntnt';
import { EMPTY_ARRAY } from '../constants/data';
const isPrimitiveParameterValue = or(isSerializableNumber, and(isString, (value) => value.length > 0));
export const parseJSONAPIParameters = (client, jsonapiParameters) => Object.keys(jsonapiParameters)
    .reduce((parameterEntries, name) => {
    const value = jsonapiParameters[name];
    switch (name) {
        case 'include': {
            return parameterEntries.concat(parseJSONAPIIncludeParameter(value));
        }
        case 'sort': {
            return parameterEntries.concat(parseJSONAPISortParameter(value));
        }
        case 'page': {
            const apiPageQuery = client.setup.createPageQuery(value);
            return parameterEntries.concat(parseJSONAPIParameter(name, apiPageQuery));
        }
        default:
            return parameterEntries.concat(parseJSONAPIParameter(name, value));
    }
}, [])
    .sort(([aName, aValue], [bName, bValue]) => {
    if (aName === bName) {
        if (aValue === bValue) {
            return 0;
        }
        return aValue > bValue ? 1 : -1;
    }
    return aName > bName ? 1 : -1;
});
export const parseJSONAPIParameter = (name, value) => {
    if (isArray(value)) {
        return parseArrayParameter(name, value);
    }
    if (isObject(value)) {
        return parseJSONAPIObjectParameter(name, value);
    }
    return parsePrimitiveParameter(name, value);
};
export const parseJSONAPIIncludeParameter = (value) => isSome(value)
    ? parseArrayParameter('include', parseJSONAPIIncludeParameterValue(EMPTY_ARRAY, value))
    : EMPTY_ARRAY;
export const parseJSONAPISortParameter = (value) => isArray(value) ? parseArrayParameter('sort', value) : EMPTY_ARRAY;
export const parseJSONAPIObjectParameter = (name, value) => Object.keys(value).flatMap((key) => parseJSONAPIParameter(`${name}[${key}]`, value[key]));
export const parsePrimitiveParameter = (name, value) => {
    if (value === true) {
        return [[name, '']];
    }
    if (isPrimitiveParameterValue(value)) {
        return [[name, String(value)]];
    }
    return EMPTY_ARRAY;
};
export const parseArrayParameter = (name, value) => parsePrimitiveParameter(name, value.filter(isPrimitiveParameterValue).join(','));
export const parseJSONAPIIncludeParameterValue = (path, value) => isSome(value)
    ? Object.keys(value)
        .sort()
        .map((name) => {
        const children = value[name];
        const childPath = path.concat(name);
        return isSome(children)
            ? parseJSONAPIIncludeParameterValue(childPath, children).join(',')
            : childPath.join('.');
    })
        .sort()
    : EMPTY_ARRAY;
//# sourceMappingURL=url.js.map